import cn from "classnames";
import { CALCULATOR_TYPES } from "constants/calculator";

import { Loading } from "components/Loading";
import { CalculatorForm } from "components/CalculatorForm";
import { Analytics } from "components/Analytics";

import { CalculatorWidgetProps } from "./CalculatorWidget.types";

import { Typography } from "shared/ui/components/Typography";

import { useWidgetOptions } from "context/widgetOptions";

import styles from "./CalculatorWidget.module.scss";


const CalculatorWidget = ({
  formClassName,
  analyticsClassName,
  domainCheck,
  analyticsType,
  isAuthenticated,
  loading,
  documentDownloadLoading,
  activePosition,
  submitLoading,
  energyEfficiencyClass,
  proCalculation,
  proCalculationCharts,
  proCalculationDocument,
  calculation,
  lastCalculatorHistory,
  initialType,
  onPositionChange,
  onCalculationClick,
  onAnalyticsTypeChange,
  onCalculatorStepChange,
  onDownloadPDFClick,

}: CalculatorWidgetProps) => {
  const { theme } = useWidgetOptions()

  if (!domainCheck && !loading) {
    return (
      <div className={styles.unavailable}>
        <Typography variant="h2">
          Calculator Unavailable
        </Typography>
      </div>
    );
  }

  return (
    <div
      className={cn(theme?.themeFont, {
        [styles.themeColor]: theme?.themeColor,
        [styles.themeTextColor]: theme?.themeTextColor,
      })}
      style={
        {
          ...(theme?.themeColor && { "--theme-color": theme.themeColor }),
          ...(theme?.themeTextColor && {
            "--text-color": theme.themeTextColor,
          }),
        } as React.CSSProperties
      }
    >
      <div id="calculator" className={styles.anchor} />
      {loading && (
        <div className={styles.loadingWrapper}>
          <Loading />
        </div>
      )}
      {!loading && (
        <>
          <CalculatorForm
            className={cn(styles.calculatorForm, formClassName)}
            analyticsType={analyticsType}
            activePosition={activePosition}
            isAuthenticated={isAuthenticated}
            submitLoading={submitLoading}
            lastCalculatorHistoryValues={lastCalculatorHistory?.values}
            variant={initialType || CALCULATOR_TYPES.BASIC}
            onCalculationClick={onCalculationClick}
            onPositionChange={onPositionChange}
            onAnalyticsTypeChange={onAnalyticsTypeChange}
          />

          {!!proCalculation && (
            <Analytics
              className={analyticsClassName}
              documentDownloadLoading={documentDownloadLoading}
              analyticsType={analyticsType}
              activePosition={activePosition}
              calculation={calculation}
              showRecalculateButton
              isAuthenticated={initialType !== CALCULATOR_TYPES.BASIC}
              energyEfficiencyClass={energyEfficiencyClass}
              proCalculation={proCalculation}
              proCalculationCharts={proCalculationCharts}
              proCalculationDocument={proCalculationDocument}
              onPositionChange={onPositionChange}
              onDownloadPDFClick={onDownloadPDFClick}
              onAnalyticsTypeChange={onAnalyticsTypeChange}
              onCalculatorStepChange={onCalculatorStepChange}
            />
          )}
        </>
      )}
    </div>
  );
};

export default CalculatorWidget;
